import React, { type JSX } from 'react';
import { Query } from '@apollo/client/react/components';
import { ApolloError } from '@apollo/client';
import {
  EkonomiskAnalysEditColumnUnitQuery as IEkonomiskAnalysEditColumnUnitQueryData,
  EkonomiskAnalysEditColumnUnitQueryVariables as IEkonomiskAnalysEditColumnUnitQueryVariables,
  EkonomiskAnalysEditColumnUnitQuery_db_LAEnhet_All,
} from './_QueryTypes/EkonomiskAnalysEditColumnUnitQuery';
import query from './EkonomiskAnalysEditColumnUnitQuery.gql';
import { TEDUrvalType } from '../../../../../../../../../../../../../Types/UrvalTypes';
import {
  TEDSelectionConditionType,
  TEDSelectionOperator,
} from '../../../../../../../../../../../../../globalQueryTypes';
import { ActiveDatabaseConsumer } from '../../../../../../../../../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';

interface IColumnUnitQueryResult {
  columnUnits?: EkonomiskAnalysEditColumnUnitQuery_db_LAEnhet_All[];
  loading: boolean;
  error?: ApolloError;
}

interface IProps {
  children: (result: IColumnUnitQueryResult) => JSX.Element;
}

const unitQuerySelection: TEDUrvalType = [
  [
    {
      namn: 'EK',
      typ: TEDSelectionConditionType.Value,
      valueCondition: {
        op: TEDSelectionOperator.equals,
        value: [{ value: 'JA' }],
      },
    },
  ],
];

const EkonomiskAnalysEditColumnUnitQuery: React.FunctionComponent<
  IProps
> = props => {
  return (
    <ActiveDatabaseConsumer>
      {({ activeDatabase }) => (
        <Query<
          IEkonomiskAnalysEditColumnUnitQueryData,
          IEkonomiskAnalysEditColumnUnitQueryVariables
        >
          query={query}
          variables={{
            dbName: activeDatabase || '',
            urval: unitQuerySelection,
          }}
          skip={!activeDatabase}
        >
          {({ data, loading, error }) => {
            const columnUnits =
              data && data.db && data.db.LAEnhet_All
                ? data.db.LAEnhet_All
                : undefined;
            return props.children({ columnUnits, loading, error });
          }}
        </Query>
      )}
    </ActiveDatabaseConsumer>
  );
};

export default EkonomiskAnalysEditColumnUnitQuery;
